import React, { useRef } from 'react';
import './blur-viewer.scss';

function generateID(prefix: string) {
  return (prefix || '') + new Date().getTime();
}

function BlurViewer(props: { image: string; children: any; className: string }) {
  const circleRef: { current: any } = useRef(null);

  let filterId = generateID('filter-');
  let maskId = generateID('mask-');

  function updateCirclePosition(event: any) {
    let posX = event.clientX;
    let posY = event.clientY;

    circleRef.current.setAttribute('cx', posX + 'px');
    circleRef.current.setAttribute('cy', posY + 'px');
  }

  return (
    <div className={`wrapper ${props.className}`}>
      <div className='blur-wrapper' onMouseMove={updateCirclePosition}>
        <img className='blur-image' src={props.image} alt='' />

        <svg className='blur' width='100%'>
          <filter id={filterId}>
            <feGaussianBlur stdDeviation='10' colorInterpolationFilters='sRGB' />
          </filter>

          <mask className='mask' id={maskId}>
            <circle ref={circleRef} cx='-50%' cy='-50%' r='120' fill='white' filter={`url(#${filterId})`} />
          </mask>

          <image xlinkHref={props.image} width='100%' height='100%' filter={`url(#${filterId})`}></image>
          <image xlinkHref={props.image} width='100%' height='100%' mask={`url(#${maskId})`}></image>
        </svg>

        {props.children}
      </div>
    </div>
  );
}

export default BlurViewer;
